import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';

import { TaxationInfoComponent } from './taxation-info.component';

@NgModule({
    imports: [CommonModule, TrustPipe],
    declarations: [TaxationInfoComponent],
    exports: [TaxationInfoComponent],
    providers: [],
})
export class TaxationInfoModule {}
